import React from 'react';
import classNames from 'classnames';
import proptypes from 'prop-types';
const { bool, number, oneOf, oneOfType, shape, string, func } = proptypes;
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './video-player.module.scss';

export const VideoStill = ({
  enableB2CRadius,
  height,
  width,
  videoStill,
  onPlayButtonClick
}) => {
  const videoStillWrapperStyle = classNames(
    styles['video-player__wrapper'],
    styles['video-player__wrapper--still'],
    { 'sui-rounded-xl': enableB2CRadius }
  );
  const videoStillImageStyle = classNames(
    styles['video-player__still'],
    { 'sui-rounded-xl': enableB2CRadius }
  );
  const playButtonStyles = classNames(styles['video-player__play-button']);

  return (
    <div
      className={styles['video-player__container']}
      style={{
        width,
        maxWidth: width,
      }}
      data-component="VideoStill"
    >
      <div className={videoStillWrapperStyle}>
        <Image
          alt="thumbnail"
          className={videoStillImageStyle}
          height={height}
          src={videoStill}
          width={width}
        />
        <button
          alt="Play Button"
          aria-label="play video"
          className={playButtonStyles}
          onClick={onPlayButtonClick}
          type="button"
        />
      </div>
    </div>
  );
};

VideoStill.propTypes = {
  enableB2CRadius: bool,
  videoStill: string.isRequired,
  height: number,
  width: number,
  onPlayButtonClick: func.isRequired
};

VideoStill.defaultProps = {
  enableB2CRadius: false,
  height: null,
  width: null,
};